// Look up `param` in an SPD/BBR-style response object using case-insensitive key matching.
// CMS output params are typically UPPERCASE (e.g. MAKE) while API responses often use
// camelCase (e.g. make) or PascalCase — this helper bridges that mismatch.
export const getResponseValueByParam = <T = unknown>(
	obj: Record<string, T> | undefined | null,
	param: string | undefined | null
): T | undefined => {
	if (!obj || !param) return undefined;
	const target = param.toLowerCase();
	const key = Object.keys(obj).find((k) => k.toLowerCase() === target);
	return key !== undefined ? obj[key] : undefined;
};
